// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_common_api.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DataMsgBodyType } from "./plugnmeet_datamessage_pb";
import { file_plugnmeet_datamessage } from "./plugnmeet_datamessage_pb";
import type { ClientType, NatsSubjects } from "./plugnmeet_nats_msg_pb";
import { file_plugnmeet_nats_msg } from "./plugnmeet_nats_msg_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_common_api.proto.
 */
export const file_plugnmeet_common_api: GenFile = /*@__PURE__*/
  fileDesc("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", [file_plugnmeet_datamessage, file_plugnmeet_nats_msg]);

/**
 * @generated from message plugnmeet.CommonResponse
 */
export type CommonResponse = Message<"plugnmeet.CommonResponse"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.CommonResponse.
 * Use `create(CommonResponseSchema)` to create a new message.
 */
export const CommonResponseSchema: GenMessage<CommonResponse> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 0);

/**
 * @generated from message plugnmeet.VerifyTokenReq
 */
export type VerifyTokenReq = Message<"plugnmeet.VerifyTokenReq"> & {
  /**
   * @generated from field: optional bool is_production = 1;
   */
  isProduction?: boolean | undefined;
};

/**
 * Describes the message plugnmeet.VerifyTokenReq.
 * Use `create(VerifyTokenReqSchema)` to create a new message.
 */
export const VerifyTokenReqSchema: GenMessage<VerifyTokenReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 1);

/**
 * @generated from message plugnmeet.VerifyTokenRes
 */
export type VerifyTokenRes = Message<"plugnmeet.VerifyTokenRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: repeated string nats_ws_urls = 3;
   */
  natsWsUrls: string[];

  /**
   * @generated from field: optional string server_version = 4;
   */
  serverVersion?: string | undefined;

  /**
   * @generated from field: optional string room_id = 5;
   */
  roomId?: string | undefined;

  /**
   * @generated from field: optional string user_id = 6;
   */
  userId?: string | undefined;

  /**
   * @generated from field: optional string room_stream_name = 7;
   */
  roomStreamName?: string | undefined;

  /**
   * @generated from field: optional plugnmeet.NatsSubjects nats_subjects = 8;
   */
  natsSubjects?: NatsSubjects | undefined;

  /**
   * @generated from field: optional bool enabled_self_insert_encryption_key = 9;
   */
  enabledSelfInsertEncryptionKey?: boolean | undefined;

  /**
   * @generated from field: optional bool is_cloud = 10;
   */
  isCloud?: boolean | undefined;

  /**
   * echoed from the token claims; web client enters hybrid UI when HYBRID_WEB
   *
   * @generated from field: plugnmeet.ClientType client_type = 11;
   */
  clientType: ClientType;
};

/**
 * Describes the message plugnmeet.VerifyTokenRes.
 * Use `create(VerifyTokenResSchema)` to create a new message.
 */
export const VerifyTokenResSchema: GenMessage<VerifyTokenRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 2);

/**
 * @generated from message plugnmeet.MuteUnMuteTrackReq
 */
export type MuteUnMuteTrackReq = Message<"plugnmeet.MuteUnMuteTrackReq"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string track_sid = 4;
   */
  trackSid: string;

  /**
   * @generated from field: bool muted = 5;
   */
  muted: boolean;

  /**
   * @generated from field: string Requested_user_id = 6;
   */
  RequestedUserId: string;
};

/**
 * Describes the message plugnmeet.MuteUnMuteTrackReq.
 * Use `create(MuteUnMuteTrackReqSchema)` to create a new message.
 */
export const MuteUnMuteTrackReqSchema: GenMessage<MuteUnMuteTrackReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 3);

/**
 * @generated from message plugnmeet.RemoveParticipantReq
 */
export type RemoveParticipantReq = Message<"plugnmeet.RemoveParticipantReq"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string msg = 4;
   */
  msg: string;

  /**
   * @generated from field: bool block_user = 5;
   */
  blockUser: boolean;
};

/**
 * Describes the message plugnmeet.RemoveParticipantReq.
 * Use `create(RemoveParticipantReqSchema)` to create a new message.
 */
export const RemoveParticipantReqSchema: GenMessage<RemoveParticipantReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 4);

/**
 * @generated from message plugnmeet.DataMessageReq
 */
export type DataMessageReq = Message<"plugnmeet.DataMessageReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 2;
   */
  roomSid: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string user_sid = 4;
   */
  userSid: string;

  /**
   * @generated from field: plugnmeet.DataMsgBodyType msg_body_type = 5;
   */
  msgBodyType: DataMsgBodyType;

  /**
   * @generated from field: string msg = 6;
   */
  msg: string;

  /**
   * @generated from field: string Requested_user_id = 7;
   */
  RequestedUserId: string;

  /**
   * @generated from field: repeated string send_to = 8;
   */
  sendTo: string[];

  /**
   * @generated from field: bool is_admin = 9;
   */
  isAdmin: boolean;
};

/**
 * Describes the message plugnmeet.DataMessageReq.
 * Use `create(DataMessageReqSchema)` to create a new message.
 */
export const DataMessageReqSchema: GenMessage<DataMessageReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 5);

/**
 * @generated from message plugnmeet.RoomEndAPIReq
 */
export type RoomEndAPIReq = Message<"plugnmeet.RoomEndAPIReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.RoomEndAPIReq.
 * Use `create(RoomEndAPIReqSchema)` to create a new message.
 */
export const RoomEndAPIReqSchema: GenMessage<RoomEndAPIReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 6);

/**
 * @generated from message plugnmeet.ChangeVisibilityRes
 */
export type ChangeVisibilityRes = Message<"plugnmeet.ChangeVisibilityRes"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: optional bool visible_notepad = 2;
   */
  visibleNotepad?: boolean | undefined;

  /**
   * @generated from field: optional bool visible_white_board = 3;
   */
  visibleWhiteBoard?: boolean | undefined;
};

/**
 * Describes the message plugnmeet.ChangeVisibilityRes.
 * Use `create(ChangeVisibilityResSchema)` to create a new message.
 */
export const ChangeVisibilityResSchema: GenMessage<ChangeVisibilityRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 7);

/**
 * @generated from message plugnmeet.SwitchPresenterReq
 */
export type SwitchPresenterReq = Message<"plugnmeet.SwitchPresenterReq"> & {
  /**
   * @generated from field: plugnmeet.SwitchPresenterTask task = 1;
   */
  task: SwitchPresenterTask;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * @generated from field: string Requested_user_id = 4;
   */
  RequestedUserId: string;
};

/**
 * Describes the message plugnmeet.SwitchPresenterReq.
 * Use `create(SwitchPresenterReqSchema)` to create a new message.
 */
export const SwitchPresenterReqSchema: GenMessage<SwitchPresenterReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 8);

/**
 * @generated from message plugnmeet.ExternalMediaPlayerReq
 */
export type ExternalMediaPlayerReq = Message<"plugnmeet.ExternalMediaPlayerReq"> & {
  /**
   * @generated from field: plugnmeet.ExternalMediaPlayerTask task = 1;
   */
  task: ExternalMediaPlayerTask;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string | undefined;

  /**
   * @generated from field: optional double seek_to = 3;
   */
  seekTo?: number | undefined;

  /**
   * @generated from field: string room_id = 4;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;
};

/**
 * Describes the message plugnmeet.ExternalMediaPlayerReq.
 * Use `create(ExternalMediaPlayerReqSchema)` to create a new message.
 */
export const ExternalMediaPlayerReqSchema: GenMessage<ExternalMediaPlayerReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 9);

/**
 * @generated from message plugnmeet.ExternalDisplayLinkReq
 */
export type ExternalDisplayLinkReq = Message<"plugnmeet.ExternalDisplayLinkReq"> & {
  /**
   * @generated from field: plugnmeet.ExternalDisplayLinkTask task = 1;
   */
  task: ExternalDisplayLinkTask;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string | undefined;

  /**
   * @generated from field: string room_id = 4;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;
};

/**
 * Describes the message plugnmeet.ExternalDisplayLinkReq.
 * Use `create(ExternalDisplayLinkReqSchema)` to create a new message.
 */
export const ExternalDisplayLinkReqSchema: GenMessage<ExternalDisplayLinkReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 10);

/**
 * @generated from message plugnmeet.CreateEtherpadSessionRes
 */
export type CreateEtherpadSessionRes = Message<"plugnmeet.CreateEtherpadSessionRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: optional string pad_id = 3;
   */
  padId?: string | undefined;

  /**
   * @generated from field: optional string readonly_pad_id = 4;
   */
  readonlyPadId?: string | undefined;
};

/**
 * Describes the message plugnmeet.CreateEtherpadSessionRes.
 * Use `create(CreateEtherpadSessionResSchema)` to create a new message.
 */
export const CreateEtherpadSessionResSchema: GenMessage<CreateEtherpadSessionRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 11);

/**
 * @generated from message plugnmeet.CleanEtherpadReq
 */
export type CleanEtherpadReq = Message<"plugnmeet.CleanEtherpadReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string pad_id = 3;
   */
  padId: string;
};

/**
 * Describes the message plugnmeet.CleanEtherpadReq.
 * Use `create(CleanEtherpadReqSchema)` to create a new message.
 */
export const CleanEtherpadReqSchema: GenMessage<CleanEtherpadReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 12);

/**
 * @generated from message plugnmeet.ChangeEtherpadStatusReq
 */
export type ChangeEtherpadStatusReq = Message<"plugnmeet.ChangeEtherpadStatusReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;
};

/**
 * Describes the message plugnmeet.ChangeEtherpadStatusReq.
 * Use `create(ChangeEtherpadStatusReqSchema)` to create a new message.
 */
export const ChangeEtherpadStatusReqSchema: GenMessage<ChangeEtherpadStatusReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 13);

/**
 * @generated from message plugnmeet.ApproveWaitingUsersReq
 */
export type ApproveWaitingUsersReq = Message<"plugnmeet.ApproveWaitingUsersReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message plugnmeet.ApproveWaitingUsersReq.
 * Use `create(ApproveWaitingUsersReqSchema)` to create a new message.
 */
export const ApproveWaitingUsersReqSchema: GenMessage<ApproveWaitingUsersReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 14);

/**
 * @generated from message plugnmeet.UpdateWaitingRoomMessageReq
 */
export type UpdateWaitingRoomMessageReq = Message<"plugnmeet.UpdateWaitingRoomMessageReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;
};

/**
 * Describes the message plugnmeet.UpdateWaitingRoomMessageReq.
 * Use `create(UpdateWaitingRoomMessageReqSchema)` to create a new message.
 */
export const UpdateWaitingRoomMessageReqSchema: GenMessage<UpdateWaitingRoomMessageReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 15);

/**
 * @generated from message plugnmeet.UpdateUserLockSettingsReq
 */
export type UpdateUserLockSettingsReq = Message<"plugnmeet.UpdateUserLockSettingsReq"> & {
  /**
   * @generated from field: string room_sid = 1;
   */
  roomSid: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string service = 4;
   */
  service: string;

  /**
   * @generated from field: string direction = 5;
   */
  direction: string;

  /**
   * @generated from field: string Requested_user_id = 6;
   */
  RequestedUserId: string;
};

/**
 * Describes the message plugnmeet.UpdateUserLockSettingsReq.
 * Use `create(UpdateUserLockSettingsReqSchema)` to create a new message.
 */
export const UpdateUserLockSettingsReqSchema: GenMessage<UpdateUserLockSettingsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 16);

/**
 * @generated from message plugnmeet.UploadBase64EncodedDataReq
 */
export type UploadBase64EncodedDataReq = Message<"plugnmeet.UploadBase64EncodedDataReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string data = 3;
   */
  data: string;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: plugnmeet.RoomUploadedFileType file_type = 5;
   */
  fileType: RoomUploadedFileType;
};

/**
 * Describes the message plugnmeet.UploadBase64EncodedDataReq.
 * Use `create(UploadBase64EncodedDataReqSchema)` to create a new message.
 */
export const UploadBase64EncodedDataReqSchema: GenMessage<UploadBase64EncodedDataReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 17);

/**
 * @generated from message plugnmeet.UploadBase64EncodedDataRes
 */
export type UploadBase64EncodedDataRes = Message<"plugnmeet.UploadBase64EncodedDataRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: string file_path = 3;
   */
  filePath: string;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string file_extension = 5;
   */
  fileExtension: string;

  /**
   * @generated from field: string file_mime_type = 6;
   */
  fileMimeType: string;
};

/**
 * Describes the message plugnmeet.UploadBase64EncodedDataRes.
 * Use `create(UploadBase64EncodedDataResSchema)` to create a new message.
 */
export const UploadBase64EncodedDataResSchema: GenMessage<UploadBase64EncodedDataRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 18);

/**
 * @generated from message plugnmeet.UploadedFileMergeReq
 */
export type UploadedFileMergeReq = Message<"plugnmeet.UploadedFileMergeReq"> & {
  /**
   * @generated from field: string room_sid = 1;
   */
  roomSid: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: plugnmeet.RoomUploadedFileType file_type = 3;
   */
  fileType: RoomUploadedFileType;

  /**
   * @generated from field: string resumable_identifier = 4;
   */
  resumableIdentifier: string;

  /**
   * @generated from field: string resumable_filename = 5;
   */
  resumableFilename: string;

  /**
   * @generated from field: int32 resumable_total_chunks = 6;
   */
  resumableTotalChunks: number;
};

/**
 * Describes the message plugnmeet.UploadedFileMergeReq.
 * Use `create(UploadedFileMergeReqSchema)` to create a new message.
 */
export const UploadedFileMergeReqSchema: GenMessage<UploadedFileMergeReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 19);

/**
 * @generated from message plugnmeet.UploadedFileRes
 */
export type UploadedFileRes = Message<"plugnmeet.UploadedFileRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: string file_id = 3;
   */
  fileId: string;

  /**
   * @generated from field: string file_path = 4;
   */
  filePath: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: string file_extension = 6;
   */
  fileExtension: string;

  /**
   * @generated from field: string file_mime_type = 7;
   */
  fileMimeType: string;

  /**
   * @generated from field: plugnmeet.RoomUploadedFileType file_type = 8;
   */
  fileType: RoomUploadedFileType;
};

/**
 * Describes the message plugnmeet.UploadedFileRes.
 * Use `create(UploadedFileResSchema)` to create a new message.
 */
export const UploadedFileResSchema: GenMessage<UploadedFileRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 20);

/**
 * @generated from message plugnmeet.RoomUploadedFileMetadata
 */
export type RoomUploadedFileMetadata = Message<"plugnmeet.RoomUploadedFileMetadata"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string file_path = 3;
   */
  filePath: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * @generated from field: string uploaded_by_user_id = 5;
   */
  uploadedByUserId: string;

  /**
   * @generated from field: string uploaded_by_name = 6;
   */
  uploadedByName: string;

  /**
   * @generated from field: plugnmeet.RoomUploadedFileType file_type = 7;
   */
  fileType: RoomUploadedFileType;

  /**
   * @generated from field: optional int32 total_pages = 8;
   */
  totalPages?: number | undefined;
};

/**
 * Describes the message plugnmeet.RoomUploadedFileMetadata.
 * Use `create(RoomUploadedFileMetadataSchema)` to create a new message.
 */
export const RoomUploadedFileMetadataSchema: GenMessage<RoomUploadedFileMetadata> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 21);

/**
 * @generated from message plugnmeet.GetRoomUploadedFilesReq
 */
export type GetRoomUploadedFilesReq = Message<"plugnmeet.GetRoomUploadedFilesReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: plugnmeet.RoomUploadedFileType file_type = 2;
   */
  fileType: RoomUploadedFileType;
};

/**
 * Describes the message plugnmeet.GetRoomUploadedFilesReq.
 * Use `create(GetRoomUploadedFilesReqSchema)` to create a new message.
 */
export const GetRoomUploadedFilesReqSchema: GenMessage<GetRoomUploadedFilesReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 22);

/**
 * @generated from message plugnmeet.GetRoomUploadedFilesRes
 */
export type GetRoomUploadedFilesRes = Message<"plugnmeet.GetRoomUploadedFilesRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: repeated plugnmeet.RoomUploadedFileMetadata files = 3;
   */
  files: RoomUploadedFileMetadata[];
};

/**
 * Describes the message plugnmeet.GetRoomUploadedFilesRes.
 * Use `create(GetRoomUploadedFilesResSchema)` to create a new message.
 */
export const GetRoomUploadedFilesResSchema: GenMessage<GetRoomUploadedFilesRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 23);

/**
 * @generated from message plugnmeet.EnableSipDialInReq
 */
export type EnableSipDialInReq = Message<"plugnmeet.EnableSipDialInReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: bool hide_phone_number = 2;
   */
  hidePhoneNumber: boolean;
};

/**
 * Describes the message plugnmeet.EnableSipDialInReq.
 * Use `create(EnableSipDialInReqSchema)` to create a new message.
 */
export const EnableSipDialInReqSchema: GenMessage<EnableSipDialInReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_common_api, 24);

/**
 * @generated from enum plugnmeet.StatusCode
 */
export enum StatusCode {
  /**
   * @generated from enum value: UNKNOWN_STATUS = 0;
   */
  UNKNOWN_STATUS = 0,

  /**
   * @generated from enum value: SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: PERMISSION_DENIED = 2;
   */
  PERMISSION_DENIED = 2,

  /**
   * @generated from enum value: NOT_FOUND = 3;
   */
  NOT_FOUND = 3,

  /**
   * @generated from enum value: CONFLICT = 4;
   */
  CONFLICT = 4,

  /**
   * @generated from enum value: INVALID_TOKEN_OR_SIGNATURE = 5;
   */
  INVALID_TOKEN_OR_SIGNATURE = 5,

  /**
   * @generated from enum value: INVALID_API_KEY = 6;
   */
  INVALID_API_KEY = 6,

  /**
   * @generated from enum value: INTERNAL_SERVER_ERROR = 7;
   */
  INTERNAL_SERVER_ERROR = 7,

  /**
   * @generated from enum value: INVALID_PARAMETERS = 8;
   */
  INVALID_PARAMETERS = 8,

  /**
   * @generated from enum value: MISSING_REQUIRED_PARAMETER = 9;
   */
  MISSING_REQUIRED_PARAMETER = 9,

  /**
   * @generated from enum value: ROOM_NOT_FOUND = 10;
   */
  ROOM_NOT_FOUND = 10,

  /**
   * @generated from enum value: USER_NOT_FOUND = 11;
   */
  USER_NOT_FOUND = 11,

  /**
   * @generated from enum value: USER_BLOCKED = 12;
   */
  USER_BLOCKED = 12,

  /**
   * @generated from enum value: USER_NOT_ACTIVE = 13;
   */
  USER_NOT_ACTIVE = 13,

  /**
   * @generated from enum value: ROOM_NOT_ACTIVE = 14;
   */
  ROOM_NOT_ACTIVE = 14,
}

/**
 * Describes the enum plugnmeet.StatusCode.
 */
export const StatusCodeSchema: GenEnum<StatusCode> = /*@__PURE__*/
  enumDesc(file_plugnmeet_common_api, 0);

/**
 * @generated from enum plugnmeet.SwitchPresenterTask
 */
export enum SwitchPresenterTask {
  /**
   * @generated from enum value: PROMOTE = 0;
   */
  PROMOTE = 0,

  /**
   * @generated from enum value: DEMOTE = 1;
   */
  DEMOTE = 1,
}

/**
 * Describes the enum plugnmeet.SwitchPresenterTask.
 */
export const SwitchPresenterTaskSchema: GenEnum<SwitchPresenterTask> = /*@__PURE__*/
  enumDesc(file_plugnmeet_common_api, 1);

/**
 * @generated from enum plugnmeet.ExternalMediaPlayerTask
 */
export enum ExternalMediaPlayerTask {
  /**
   * @generated from enum value: START_PLAYBACK = 0;
   */
  START_PLAYBACK = 0,

  /**
   * @generated from enum value: END_PLAYBACK = 1;
   */
  END_PLAYBACK = 1,
}

/**
 * Describes the enum plugnmeet.ExternalMediaPlayerTask.
 */
export const ExternalMediaPlayerTaskSchema: GenEnum<ExternalMediaPlayerTask> = /*@__PURE__*/
  enumDesc(file_plugnmeet_common_api, 2);

/**
 * @generated from enum plugnmeet.ExternalDisplayLinkTask
 */
export enum ExternalDisplayLinkTask {
  /**
   * @generated from enum value: START_EXTERNAL_LINK = 0;
   */
  START_EXTERNAL_LINK = 0,

  /**
   * @generated from enum value: STOP_EXTERNAL_LINK = 1;
   */
  STOP_EXTERNAL_LINK = 1,
}

/**
 * Describes the enum plugnmeet.ExternalDisplayLinkTask.
 */
export const ExternalDisplayLinkTaskSchema: GenEnum<ExternalDisplayLinkTask> = /*@__PURE__*/
  enumDesc(file_plugnmeet_common_api, 3);

/**
 * @generated from enum plugnmeet.RoomUploadedFileType
 */
export enum RoomUploadedFileType {
  /**
   * @generated from enum value: CHAT_FILE = 0;
   */
  CHAT_FILE = 0,

  /**
   * @generated from enum value: WHITEBOARD_IMAGE_FILE = 1;
   */
  WHITEBOARD_IMAGE_FILE = 1,

  /**
   * @generated from enum value: WHITEBOARD_CONVERTED_FILE = 2;
   */
  WHITEBOARD_CONVERTED_FILE = 2,

  /**
   * @generated from enum value: EXTERNAL_MEDIA_PLAYER_FILE = 3;
   */
  EXTERNAL_MEDIA_PLAYER_FILE = 3,

  /**
   * @generated from enum value: VIRTUAL_BACKGROUND = 4;
   */
  VIRTUAL_BACKGROUND = 4,
}

/**
 * Describes the enum plugnmeet.RoomUploadedFileType.
 */
export const RoomUploadedFileTypeSchema: GenEnum<RoomUploadedFileType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_common_api, 4);

